import FreeCouponView from 'src/pages/FreeCouponPage/view'
import { QueryClient } from '@tanstack/react-query'
import {
  FreeCouponListQueryOption,
  useCustomQuery,
} from 'src/hooks/react-query/useCustomQuery.hook'
import { FreeCouponListSpace } from 'src/types/api'
import usePageNav from 'src/hooks/usePageNav.hook'
import React from 'react'
import RenderIf from 'src/components/common/RenderIf'
import { Loading } from 'src/components/common/Loading'
import { useModal } from 'src/provider/ModalContextProvider'
import { useGlobalStore } from 'src/store/zustand'

export interface FreeCouponPageProps {
  FreeCouponListData?: FreeCouponListSpace.FreeCouponTypes[]
  freeCouponDetailNav: (idx: number, status: number) => void
}

export const freeCouponPageLoader = (queryClient: QueryClient) => async () => {
  const dataQueryValues = [await queryClient.ensureQueryData(FreeCouponListQueryOption())]
  return Promise.allSettled(dataQueryValues)
}

const FreeCouponPage = () => {
  const { freeCouponDetailPageNav } = usePageNav()
  const { openModal } = useModal()
  const { maintenanceBlock } = useGlobalStore()

  const { data: freeCouponListData, isLoading: isFreeCouponListLoading } =
    useCustomQuery<FreeCouponListSpace.Response>(FreeCouponListQueryOption())

  const freeCouponDetailNav = (idx: number, status: number) => {
    const isNotCouponDownLoad = status === 0
    const isCouponNonUsed = status === 1
    const isUsable = isCouponNonUsed || isNotCouponDownLoad

    if (!!maintenanceBlock) {
      openModal({
        contents: { t: maintenanceBlock.t, d: maintenanceBlock.d },
        button: { submit: { t: '확인' } },
      })
      return
    }

    if (isUsable) {
      freeCouponDetailPageNav(idx)
    } else return
  }

  const props = {
    FreeCouponListData: freeCouponListData?.Body?.FreeCoupon,
    freeCouponDetailNav,
  }

  return (
    <React.Fragment>
      <RenderIf when={isFreeCouponListLoading}>
        <Loading.Default />
      </RenderIf>
      <FreeCouponView {...props} />
    </React.Fragment>
  )
}
export default FreeCouponPage
